<template>
    <!-- Bare, transparent container — the cards float on the page (no frame, bar, or white line below). HAP-4166 -->
    <div class="w-full relative overflow-hidden">
        <div class="snap-x snap-mandatory flex overflow-x-auto pt-8 pb-12 w-full no-sb" ref="images">
            <div class="w-[14%] md:w-[20%] shrink-0"></div>
            <button
                v-for="rotator, index in rotators"
                :key="rotator.id"
                class="group w-[72%] md:w-3/5 shrink-0 snap-center px-3 snap-always"
                @click="selectedImageIndex == index ? openLink(rotator) : scrollToCard(index)"
            >
                <div
                    :style="`background-image: url(${rotator.image.url});`"
                    class="w-full h-[300px] md:h-[420px] xl:h-[500px] 2xl:h-[580px] bg-cover bg-center rounded-2xl shadow-[0_24px_50px_-18px_rgba(0,0,0,0.45)] transition-all duration-500 flex flex-col justify-between p-6"
                    :class="selectedImageIndex == index ? '' : 'opacity-40 md:scale-95'"
                >
                    <div v-if="rotator.rotatorType" class="text-xs tracking-widest uppercase text-ncfic-blue-500 font-bold text-center drop-shadow-[2px 2px 5px rgb(0 0 0)] flex justify-center">
                        <div class="bg-black/30 backdrop-blur px-2 py-1 rounded shadow-card">{{ rotator.rotatorType }}</div>
                    </div>
                    <div v-else></div>
                    <div v-if="rotator.titleImage?.url" class="flex-1 min-h-0 flex items-center justify-center py-2">
                        <img :src="rotator.titleImage.url" :alt="rotator.title || ''" class="w-full max-w-md max-h-full object-contain mx-auto" />
                    </div>
                    <div class="text-white text-center">
                        <div v-if="rotator.title" class="text-lg font-bold">{{ rotator.title }}</div>
                        <div class="text-sm opacity-80 font-semibold">{{ rotator.subtitle }}</div>
                    </div>
                </div>
            </button>
            <div class="w-[14%] md:w-[20%] shrink-0"></div>
        </div>
        <div v-if="rotators?.length > 1" class="w-full flex items-center justify-center space-x-2 pb-4">
            <div v-for="i, index in rotators" :key="i" @click="scrollToCard(index)">
                <div class="w-2 h-2 rounded-full transition-all bg-white cursor-pointer" :class="selectedImageIndex == index ? 'scale-110' : 'opacity-50'"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['rotators'],
    inject: ['store'],
    data() {
        return {
            selectedImageIndex: 0,
            looper: null,
            autoScrolling: false,
            lastInteraction: 0,
            settleTimeout: null,
        }
    },
    mounted() {
        this.$refs.images.addEventListener('scroll', this.onScroll)
        // Auto-advance every 6s; pauses briefly after any manual interaction.
        this.looper = setInterval(() => {
            if (!this.rotators || this.rotators.length < 2) return
            if (Date.now() - this.lastInteraction < 9000) return
            this.goTo((this.selectedImageIndex + 1) % this.rotators.length)
        }, 6000)
    },
    beforeUnmount() {
        this.$refs.images?.removeEventListener('scroll', this.onScroll)
        clearInterval(this.looper)
        clearTimeout(this.settleTimeout)
    },
    methods: {
        openLink(rotator) {
            this.store.openType = 'popIn'
            this.$router.push(rotator?.target)
        },
        scrollToCard(index) {
            // user-initiated (dot click / side card click)
            this.lastInteraction = Date.now()
            this.goTo(index)
        },
        goTo(index) {
            this.selectedImageIndex = index
            let row = this.$refs.images
            if (!row) return
            let btn = row.querySelectorAll('button')[index]
            if (!btn) return
            let left = btn.offsetLeft - (row.clientWidth - btn.clientWidth) / 2
            this.autoScrolling = true
            row.scrollTo({ left, behavior: 'smooth' })
            clearTimeout(this.settleTimeout)
            this.settleTimeout = setTimeout(() => (this.autoScrolling = false), 800)
        },
        onScroll() {
            let row = this.$refs.images
            if (!row) return
            let btns = [...row.querySelectorAll('button')]
            let center = row.scrollLeft + row.clientWidth / 2
            let best = 0,
                bestDist = Infinity
            btns.forEach((b, i) => {
                let bCenter = b.offsetLeft + b.clientWidth / 2
                let d = Math.abs(bCenter - center)
                if (d < bestDist) {
                    bestDist = d
                    best = i
                }
            })
            this.selectedImageIndex = best
            // Only a manual (non-programmatic) scroll counts as interaction.
            if (!this.autoScrolling) this.lastInteraction = Date.now()
        },
    },
}
</script>

<style>
.overflow-x-auto::-webkit-scrollbar {
    display: none;
}
</style>
